global.$ = global.jQuery = require('jquery');

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import AOS from 'aos';
import 'aos/dist/aos.css';

import Headroom from "headroom.js";

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
window.Swiper = Swiper;

$(document).ready(function() {

    // Sticky scroll Header
    if ($('header.headroom').length > 0) {
        let headroomEl = document.querySelector("header");
        var headerHeadroom  = new Headroom(headroomEl)
        headerHeadroom.init();
        global.headerHeadroom = headerHeadroom;
    }

    const mainMenu = $('.header__main-menu');
    const body = $('body');
    $('.burgermenu').click(function (e) {
        e.preventDefault();
        if (!$(this).hasClass('open')) {
            mainMenu.addClass('open');
            $(this).addClass('open');
            body.addClass('no-scroll-y');
        } else {
            $(this).removeClass('open');
            mainMenu.removeClass('open');
            body.removeClass('no-scroll-y');
        }
    });

    // To-top button
    const toTopBtn = $('#to-top');
    $(window).scroll(function(){
        if ($(window).scrollTop() > 300) {
            toTopBtn.fadeIn();
        } else {
            toTopBtn.fadeOut();
        }
    });
    toTopBtn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 'slow');
    });

    // Animations
    // AOS animations
    $(function() {
        AOS.init({
            duration: 700,
            offset: 50,
            once: true,
        });
    });

    // collapse effects
    let opener = $('.collapse-opener');
    let wclosed = $('.w-closed');
    let wopen = $('.w-open');
    opener.click(function(e) {
        e.stopPropagation();
        if($(this).hasClass('collapsed')){
            $(this).find(wclosed).show();
            $(this).find(wopen).hide();
        } else {
            $(this).find(wclosed).hide();
            $(this).find(wopen).show();
        }
    });

    $('.chars-collapses .collapse').on('shown.bs.collapse', function () {
        this.scrollIntoView();
    });

    var contactSelect = $('#mauticform_input_formcontattisuperfryit_paese option:selected').text();
    var experienceSelect = $('#mauticform_input_formexperiencesuperfryit_paese option:selected').text();

    showProvincia($("#mauticform_formcontattisuperfryit_provincia"), contactSelect);
    showProvincia($("#mauticform_formexperiencesuperfryit_provincia"), experienceSelect);

    $('#mauticform_input_formcontattisuperfryit_paese').on('change', function (e) {
        showProvincia($("#mauticform_formcontattisuperfryit_provincia"), this.value);
    });

    $('#mauticform_input_formexperiencesuperfryit_paese').on('change', function (e) {
        showProvincia($("#mauticform_formexperiencesuperfryit_provincia"), this.value);
    });

    let subMenuOpener = $('.header__main-menu .links-opener');
    let subMenuOpenerS = $('.header__main-menu .links-opener > span');
    let subMenu = $('.header__submenu');
    let mobSubMenu = $('.mobile-submenu-wrapper');
    let activeM;
    if (window.innerWidth >= 1501){
        subMenuOpener.hover(function (e) {
            $(this).addClass('active');
            if (activeM !== $(this).data('sub')){
                activeM = $(this).data('sub');
                $('.subber').each(function () {
                    $(this).animate({opacity: 0}, 100).css('pointer-events','none');
                })
            }
            $('.subber.'+$(this).data('sub')).each(function () {
                $(this).animate({opacity: 1}, 300).css('pointer-events','auto');
            })
            subMenu.stop().slideDown(400);
            e.stopPropagation()
        },function (e){
            $(this).removeClass('active');
            subMenu.stop().slideUp(400);
            e.stopPropagation()
        });

        subMenu.hover(function (e) {
            subMenu.stop().slideDown(400);
            e.stopPropagation()
        }, function (e) {
            subMenu.stop().slideUp(400);
            e.stopPropagation()
        });

        $('.subber').hover(function (e) {
            console.log($(this).data('id'))
            if (!$('#'+$(this).data('id')).hasClass('active')){
                $('#'+$(this).data('id')).addClass('active');
            }
            // subMenu.stop().slideDown(400);
            // e.stopPropagation()
        }, function (e) {
            if ($('#'+$(this).data('id')).hasClass('active')){
                $('#'+$(this).data('id')).removeClass('active');
            }
            // subMenu.stop().slideUp(400);
            // e.stopPropagation()
        });
    } else {
        subMenuOpenerS.on('click', function (e) {
            e.preventDefault()
            if ($(this).parent().closest('.links-opener').hasClass('open')){
                $(this).closest('.links-opener').find('.mobile-submenu-wrapper').stop().slideUp(400);
                $(this).closest('.links-opener').removeClass('open');
            } else {
                $(this).closest('.links-opener').find('.mobile-submenu-wrapper').stop().slideDown(400);
                $(this).closest('.links-opener').addClass('open');
            }
        })
    }

    // $('.accordion-collapse').on('shown.bs.collapse', function (e) {
    //     let $panel = $(this).closest('.accordion-item');
    //     $('html,body').animate({
    //         scrollTop: $panel.offset().top - 100
    //     }, 200);
    // });

});

function showProvincia(objectPaese, value){
    if (value == "Italy") {
        objectPaese.fadeIn(500).removeClass('d-none');
    } else{
        objectPaese.fadeOut(500);
    }
}
